import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ShieldAlert } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/admin/login", { email, password });
      await login(data.token);
      navigate("/admin");
    } catch (e) {
      toast.error(errMsg(e, "Identifiants invalides"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center px-6 relative overflow-hidden">
      <div className="pointer-events-none absolute -top-40 -right-40 w-[520px] h-[520px] rounded-full bg-[#005CFF]/25 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-40 -left-40 w-[520px] h-[520px] rounded-full bg-[#005CFF]/10 blur-3xl" />
      <div className="w-full max-w-sm mx-auto relative">
        <ShieldAlert size={22} className="text-[#005CFF] mb-4" />
        <div className="text-xs font-bold tracking-[0.2em] uppercase text-white/50 mb-2">Back-office</div>
        <h1 className="font-display text-3xl font-extrabold tracking-tighter text-white mb-8">Équipe BKPRO</h1>
        <div className="space-y-3">
          <Input data-testid="admin-email-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@bkpro.fr" className="h-14 rounded-2xl bg-white/5 border-white/10 text-white placeholder:text-white/30" />
          <Input
            data-testid="admin-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submit()}
            placeholder="Mot de passe"
            className="h-14 rounded-2xl bg-white/5 border-white/10 text-white placeholder:text-white/30"
          />
          <Button data-testid="admin-login-btn" onClick={submit} disabled={busy} className="w-full h-14 rounded-2xl bg-[#005CFF] hover:bg-[#0047CC] font-semibold bk-glow">
            {busy ? <Loader2 className="animate-spin" size={18} /> : "Se connecter"}
          </Button>
          <a href="/login" className="block text-xs text-white/40 hover:text-white/70 pt-3">← Espace client</a>
        </div>
      </div>
    </div>
  );
}
